import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addResidenceFailure,
  addResidenceFamilyMemberFailure,
  //
  addResidenceFamilyMemberSuccess,
  addResidenceNoteFailure,
  //
  addResidenceNoteSuccess,
  addResidenceReminderFailure,
  //
  addResidenceReminderSuccess,
  //
  addResidenceSuccess,
  deleteResidenceFailure,
  deleteResidenceNoteFailure,
  //
  deleteResidenceNoteSuccess,
  deleteResidenceReminderNoteFailure,
  //
  deleteResidenceReminderNoteSuccess,
  //
  deleteResidenceSuccess,
  editResidenceFailure,
  editResidenceFamilyMemberFailure,
  //
  editResidenceFamilyMemberSuccess,
  //
  editResidenceSuccess,
  fetchResidence as fetchResidenceAction,
  fetchResidenceFailure,
  //
  fetchResidenceFamilyMembers,
  fetchResidenceFamilyMembersFailure,
  fetchResidenceFamilyMembersSuccess,
  //
  fetchResidenceNotes,
  fetchResidenceNotesFailure,
  fetchResidenceNotesSuccess,
  //
  fetchResidenceReminders,
  fetchResidenceRemindersFailure,
  fetchResidenceRemindersSuccess,
  fetchResidenceSuccess,
  getFamilyViewDataFailure,
  //
  getFamilyViewDataSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
} from "./actions";
import {
  ADD_RESIDENCE,
  ADD_RESIDENCE_FAMILY_MEMBER,
  ADD_RESIDENCE_NOTE,
  ADD_RESIDENCE_REMINDER,
  DELETE_RESIDENCE,
  DELETE_RESIDENCE_NOTE,
  DELETE_RESIDENCE_REMINDER_NOTE,
  EDIT_RESIDENCE,
  EDIT_RESIDENCE_FAMILY_MEMBER,
  FETCH_RESIDENCE,
  FETCH_RESIDENCE_FAMILY_MEMBERS,
  FETCH_RESIDENCE_NOTES,
  FETCH_RESIDENCE_REMINDERS,
  GET_FAMILY_VIEW_DATA,
  GET_VIEW_DATA,
} from "./constants";

export function* fetchResidenceSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(api(token).get, `/api/residence?${query}`);
    yield put(fetchResidenceSuccess(data));
  } catch (e) {
    yield put(fetchResidenceFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching residence!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).get, `/api/residence/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addResidenceSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/residence/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Residence added successfully!"));
      yield put(addResidenceSuccess());
      if (payload?.history) {
        payload.history.push("/d/residence");
      }
    }
  } catch (e) {
    yield put(addResidenceFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editResidenceSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/residence/edit/${payload.data.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Residence updated successfully!"));
      yield put(editResidenceSuccess());
      yield put(getViewDataAction(payload.data.id));
    }
  } catch (e) {
    yield put(editResidenceFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteResidenceSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/enquiries/${payload}`);
    if (data) {
      yield put(successAlert("Residence deleted successfully!"));
      yield put(deleteResidenceSuccess());
      yield put(fetchResidenceAction());
    }
  } catch (e) {
    yield put(deleteResidenceFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteResidenceNoteSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/enquiries-notes`, payload);
    if (data) {
      yield put(successAlert("Residence Note deleted successfully!"));
      yield put(deleteResidenceNoteSuccess());
      yield put(getViewDataAction(payload.enquiry_id));
    }
  } catch (e) {
    yield put(deleteResidenceNoteFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteResidenceReminderNoteSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/delete-enquiries-reminder`,
      payload
    );
    if (data) {
      yield put(successAlert("Residence Reminder Note deleted successfully!"));
      yield put(deleteResidenceReminderNoteSuccess());
      yield put(getViewDataAction(payload.enquiry_id));
    }
  } catch (e) {
    yield put(deleteResidenceReminderNoteFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* addResidenceNoteSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/residence-notes/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Note added successfully!"));
      yield put(addResidenceNoteSuccess());
      yield put(getViewDataAction(payload.data.residence_id));
      yield put(
        fetchResidenceNotes({
          all: true,
          residence_id: payload.data.residence_id,
        })
      );
    }
  } catch (e) {
    yield put(addResidenceNoteFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchResidenceNotesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/residence-notes?${query}`
    );
    yield put(fetchResidenceNotesSuccess(data));
  } catch (e) {
    yield put(fetchResidenceNotesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching enquiries notes!"));
  }
}

export function* addResidenceReminderSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/residence-reminder/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Reminder added successfully!"));
      yield put(addResidenceReminderSuccess());
      yield put(getViewDataAction(payload.data.residence_id));
      yield put(
        fetchResidenceReminders({
          all: true,
          residence_id: payload.data.residence_id,
        })
      );
    }
  } catch (e) {
    yield put(addResidenceReminderFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchResidenceRemindersSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/residence-reminder?${query}`
    );
    yield put(fetchResidenceRemindersSuccess(data));
  } catch (e) {
    yield put(fetchResidenceRemindersFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching reminders!"));
  }
}

export function* addResidenceFamilyMemberSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/family-member/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Family member added successfully!"));
      yield put(addResidenceFamilyMemberSuccess());
      yield put(getViewDataAction(payload.data.residence_id));
      yield put(
        fetchResidenceFamilyMembers({
          all: true,
          residence_id: payload.data.residence_id,
        })
      );
    }
  } catch (e) {
    yield put(addResidenceFamilyMemberFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchResidenceFamilyMembersSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/family-member?${query}`);
    yield put(fetchResidenceFamilyMembersSuccess(data));
  } catch (e) {
    yield put(fetchResidenceFamilyMembersFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching members!"));
  }
}

export function* getFamilyViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/family-member/${payload}`
    );
    yield put(getFamilyViewDataSuccess(data));
  } catch (e) {
    yield put(getFamilyViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* editResidenceFamilyMemberSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/family-member/edit/${payload.data.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Member updated successfully!"));
      yield put(editResidenceFamilyMemberSuccess());
      yield put(getViewDataAction(payload.data.residence_id));
    }
  } catch (e) {
    yield put(editResidenceFamilyMemberFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchResidenceFlow() {
  yield takeEvery(FETCH_RESIDENCE, fetchResidenceSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addResidenceFlow() {
  yield takeEvery(ADD_RESIDENCE, addResidenceSaga);
}
export function* editResidenceFlow() {
  yield takeEvery(EDIT_RESIDENCE, editResidenceSaga);
}
export function* deleteResidenceFlow() {
  yield takeEvery(DELETE_RESIDENCE, deleteResidenceSaga);
}
export function* deleteResidenceNoteFlow() {
  yield takeEvery(DELETE_RESIDENCE_NOTE, deleteResidenceNoteSaga);
}
export function* deleteResidenceReminderNoteFlow() {
  yield takeEvery(
    DELETE_RESIDENCE_REMINDER_NOTE,
    deleteResidenceReminderNoteSaga
  );
}
export function* addResidenceNoteFlow() {
  yield takeEvery(ADD_RESIDENCE_NOTE, addResidenceNoteSaga);
}
export function* fetchResidenceNotesFlow() {
  yield takeEvery(FETCH_RESIDENCE_NOTES, fetchResidenceNotesSaga);
}
export function* addResidenceReminderFlow() {
  yield takeEvery(ADD_RESIDENCE_REMINDER, addResidenceReminderSaga);
}
export function* fetchResidenceRemindersFlow() {
  yield takeEvery(FETCH_RESIDENCE_REMINDERS, fetchResidenceRemindersSaga);
}
export function* addResidenceFamilyMemberFlow() {
  yield takeEvery(ADD_RESIDENCE_FAMILY_MEMBER, addResidenceFamilyMemberSaga);
}
export function* fetchResidenceFamilyMembersFlow() {
  yield takeEvery(
    FETCH_RESIDENCE_FAMILY_MEMBERS,
    fetchResidenceFamilyMembersSaga
  );
}
export function* getFamilyViewDataFlow() {
  yield takeEvery(GET_FAMILY_VIEW_DATA, getFamilyViewDataSaga);
}
export function* editResidenceFamilyMemberFlow() {
  yield takeEvery(EDIT_RESIDENCE_FAMILY_MEMBER, editResidenceFamilyMemberSaga);
}
export default function* ResidenceSaga() {
  yield all([
    fetchResidenceFlow(),
    addResidenceFlow(),
    editResidenceFlow(),
    deleteResidenceFlow(),
    getViewDataFlow(),
    deleteResidenceNoteFlow(),
    deleteResidenceReminderNoteFlow(),
    addResidenceNoteFlow(),
    fetchResidenceNotesFlow(),
    addResidenceReminderFlow(),
    fetchResidenceRemindersFlow(),
    addResidenceFamilyMemberFlow(),
    fetchResidenceFamilyMembersFlow(),
    getFamilyViewDataFlow(),
    editResidenceFamilyMemberFlow(),
  ]);
}
